module.exports = __webpack_public_path__ + "static/media/carro_3.6e3ec29a.png";